import { Country } from 'searchality-data';

export default () => {
  return Object.values(Country).map((value) => ({
    label: value,
    value,
  }));
};
